export default __webpack_public_path__ + "static/media/confirmation.dda38ad8.gif";